export const content = {
  activateSim: 'Activate SIM',
  active: 'Active',
  activationFailed: 'Activation failed',
  activationRequested: 'Activation requested',
  closingAccount: 'Closing account',
  closedAccount: 'Account closed',
  awaitingActivation: 'Awaiting activation',
  closing: 'Closing account',
  expired: 'Expired',
  invitationAccepted: 'Invitation accepted',
  invitationRejected: 'Invitation rejected',
  invitationSent: 'Invitation sent',
  pauseScheduled: 'Pause scheduled',
  paused: 'Paused',
  planChangePending: 'Plan change pending',
  planChangePendingToSolo: 'Plan change pending', //TODO: Update to correct copy if needed
  setup: 'Setup',
  simDispatched: 'SIM dispatched',
}
